import { isEmpty } from "lodash";
import { useMemo } from "react";

import { useCachedTag } from "src/hooks/useCachedTag";
import { useCachedGroup } from "src/hooks/useSearchGroups";
import { useCachedPerson } from "src/hooks/useSearchPeople";
import useUpdateEffect from "src/hooks/useUpdateEffect";
import {
  buildDisplayValue,
  filterTagAttributeTypes,
} from "../TagAttributeModal.logic";

const EmptyAttrTypes = [];

export const useCreateNewTagModalMeta = ({
  selectedTag,
  updatedAttributes,
  entityId,
  setDisplayValue,
}) => {
  const { getCachedGroup } = useCachedGroup();
  const { getCachedPerson } = useCachedPerson();
  const { getCachedTag } = useCachedTag();

  const {
    hasDetails,
    detailsParsed: parsedDetails,
    attributes: meta = {},
  } = selectedTag || {};

  const {
    separator = "_",
    values: nameAttrTypes = EmptyAttrTypes,
    others: otherAttrTypes = EmptyAttrTypes,
    entityTag: entityTagAttrTypes = EmptyAttrTypes,
    parentTag = EmptyAttrTypes,
  } = meta || {};

  const [readonlyAttrTypes, editableAttrTypes, uniqueAttrTypes] = useMemo(
    () =>
      filterTagAttributeTypes(
        nameAttrTypes,
        otherAttrTypes,
        entityTagAttrTypes
      ),
    [entityTagAttrTypes, nameAttrTypes, otherAttrTypes]
  );

  useUpdateEffect(() => {
    const combinedValue = buildDisplayValue({
      attrTypeValues: nameAttrTypes,
      attributes: updatedAttributes,
      separator,
      getCachedGroup: getCachedGroup as (
        id: unknown
      ) => { name?: string } | null | undefined,
      getCachedPerson,
      getCachedTag: getCachedTag as (
        id: unknown
      ) => { displayValue?: string } | null | undefined,
      entityId,
    });
    if (!isEmpty(combinedValue)) {
      setDisplayValue(combinedValue);
    }
  }, [
    nameAttrTypes,
    separator,
    updatedAttributes,
    getCachedGroup,
    getCachedPerson,
    getCachedTag,
    entityId,
    setDisplayValue,
  ]);

  return {
    hasDetails,
    parsedDetails,
    parentTag,
    readonlyAttrTypes,
    editableAttrTypes,
    uniqueAttrTypes,
  };
};
